import NoResultIcon from '@cp/src/assets/icons/NoResultIcon';
import styles from './index.module.scss';
import { Typography } from '@navi/web-ui/lib/primitives';
import EmptyListIcon from '@cp/src/assets/icons/EmptyListIcon';
import { INoResult } from '../../interface';

const NoResult = (props: INoResult) => {
  const { totalPendingApprovals } = props;

  if (totalPendingApprovals) {
    return (
      <div className={styles.selectedItem}>
        <NoResultIcon />
        <Typography variant="p1" className={styles.noResultText}>
          Make a selection from the left panel to view results
        </Typography>
      </div>
    );
  }

  return (
    <div className={styles.selectedItem}>
      <EmptyListIcon />
      <Typography variant="p1" className={styles.noResultText}>
        No search results found
      </Typography>
    </div>
  );
};

export default NoResult;
